export default "__VITE_ASSET__srwXcdDV__"